import styled from '@emotion/styled';

const FlexCenterWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
`;

export default FlexCenterWrapper;
